export default "/react/samba-b0f48f4a.svg";